import * as React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { NavigateNext } from "@mui/icons-material";
import { useTheme } from "@emotion/react";

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

export default function BasicBreadcrumbs({ first, second, third }) {
  const theme = useTheme(); // access your custom theme

  return (
    <div role="presentation" onClick={handleClick}>
      <Breadcrumbs separator={<NavigateNext fontSize="small" />}
        sx={{
          '& .MuiBreadcrumbs-ol': {
            fontWeight: "bold",
            color: "primary.main",
            textTransform: "uppercase"
          },
           '& .MuiTypography-root, & .MuititleLink-root': {
            fontWeight: theme.typography.fontWeightBold,
          },
        }}
        aria-label="breadcrumb">
        {first && <Typography variant="title" underline="hover" color="inherit">{first}</Typography>}
        {second && <Typography variant="title" color="inherit">{second}</Typography>}
        {third && <Typography variant="title" color="inherit">{third}</Typography>}
      </Breadcrumbs>
    </div>
  );
}
